export const DEFAULT_API_HOST = (import.meta.env.VITE_API_URL as string) ?? '';

let apiHostGetter: (() => string) | null = null;

/**
 * Called from app layer to provide actual apiHost from useSettingsStore.
 * If not set, getApiHost() falls back to DEFAULT_API_HOST.
 */
export const setApiHostGetter = (getter: () => string) => {
  apiHostGetter = getter;
};

export const getApiHost = (): string => {
  const value = apiHostGetter ? apiHostGetter() : DEFAULT_API_HOST;
  return value || DEFAULT_API_HOST;
};

let serviceTokenGetter: (() => string | undefined) | null = null;

/**
 * Called from entities layer to provide actual serviceToken from useSettingsStore.
 * If not set, getServiceToken() returns undefined.
 */
export const setServiceTokenGetter = (getter: () => string | undefined) => {
  serviceTokenGetter = getter;
};

export const getServiceToken = (): string | undefined => {
  return serviceTokenGetter ? serviceTokenGetter() : undefined;
};

export const getFullUrl = (url: string) => {
  if (url.startsWith('http')) {
    return url;
  }

  return `${getApiHost()}${url}`;
};
